/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class AreaService {
        constructor(private $http: ng.IHttpService, private baseService: BaseService) { }

        public getAreaCsv(fileId: string) {
            return this.baseService.get('area/{companyNumber}/csv?fileId=' + fileId).then(j => { return j.data });
        }
    }

    AreaService.$inject = ['$http', 'BaseService'];
    angular
        .module('eseebase')
        .service('AreaService', AreaService);
}